import { NgModule, LOCALE_ID } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from './services/auth.service';
import { BrandingService } from './services/branding.service';
import { TokenInterceptor } from './services/token.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ConnectionGuard } from './guards/connection.guard';
import { NoTokenAuthGuard } from './guards/no.token.guard';
import { ValidGuidAuthGuard } from './guards/valid.guid.guard';
import { ValidTokenAuthGuard } from './guards/valid.token.guard';
import { OAuthModule } from 'angular-oauth2-oidc';
import { MatSnackBarModule as MatSnackBarModule } from '@angular/material/snack-bar';
import { UserInactivityService } from './services/user-inactivity.service';
import { NotificationService } from './services/notification.service';
import { LoadingIndicatorService } from './services/loading-indicator.service';
import { PermissionAuthGuard } from './guards/permission.guard';
import { ConfirmationDialogService } from './services/confirmation-dialog.service';
import { ResponsivenessService } from './services/responsiveness.service';
import { GlobalResponsivenessService } from './services/global-responsiveness.service';
import { BreadcrumbService } from './services/breadcrumb.service';
import { CanExitGuard } from './guards/can-exit.guard';
import { AuthorizationHandlerService } from './services/errors/authorization-error-handler.service';
import { GenericErrorHandlerService } from './services/errors/generic-error-handler.service';
import { UserErrorHandlerService } from './services/errors/user-error-handler.service';
import { BusinessUnitSettingsService } from './services/business-unit-settings.service';
import { LayoutService } from './services/layout.service';
@NgModule({
  imports: [
    CommonModule,
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: ['http://localhost:49194/api'],
        sendAccessToken: true,
      },
    }),
    MatSnackBarModule,
  ],
  declarations: [],
  providers: [
    AuthService,
    BrandingService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    { provide: LOCALE_ID, useValue: 'nl-NL' },
    ConnectionGuard,
    NoTokenAuthGuard,
    ValidGuidAuthGuard,
    ValidTokenAuthGuard,
    UserInactivityService,
    NotificationService,
    LoadingIndicatorService,
    PermissionAuthGuard,
    ConfirmationDialogService,
    ResponsivenessService,
    GlobalResponsivenessService,
    BreadcrumbService,
    CanExitGuard,
    AuthorizationHandlerService,
    GenericErrorHandlerService,
    UserErrorHandlerService,
    BusinessUnitSettingsService,
    LayoutService,
  ],
})
export class CoreModule {}
